(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raashi-product"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{root.querySelectorAll('[data-raashi-product]').forEach(el=>{if(el.dataset.ready)return;el.dataset.ready='1';const dialog=el.querySelector('dialog'),image=dialog.querySelector('img');el.querySelectorAll('[data-rpd-zoom]').forEach(a=>a.addEventListener('click',e=>{if(!dialog.showModal)return;e.preventDefault();image.src=a.href;image.alt=a.querySelector('img').alt;dialog.showModal();}));el.querySelector('[data-rpd-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});el.querySelector('[data-rpd-variant]')?.addEventListener('change',e=>{location.href=e.target.dataset.url+'?variant='+encodeURIComponent(e.target.value);});const share=el.querySelector('[data-rpd-share]'),status=el.querySelector('[data-rpd-share-status]');if(navigator.share||navigator.clipboard){share.hidden=false;share.onclick=async()=>{try{if(navigator.share)await navigator.share({title:document.title,url:location.href});else{await navigator.clipboard.writeText(location.href);status.textContent=status.dataset.copied;}}catch{}};}});};init(document);document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();
})();
